import { Info } from '@mui/icons-material'
import { Box, Divider, List, ListItem, Stack, Typography } from '@mui/material'
import { useSearch } from '../hooks/useSearch'

export const NoResultsMessage = () => {
  const { searchResults } = useSearch()
  const { request } = searchResults

  const getMessage = () => {
    if (request.isUninitialized) return <BeforeSearchMessage />
    if (request.isSuccess) return <SuccessNoResults />

    //fallback
    return <BeforeSearchMessage />
  }

  return (
    <Box mt={3} maxWidth={'70ch'} ml="auto" mr="auto">
      {getMessage()}
    </Box>
  )
}

const BeforeSearchMessage = () => (
  <Typography sx={{ opacity: 0.6 }} textAlign="center">
    No results
  </Typography>
)

const SuccessNoResults = () => (
  <>
    <Stack direction="row" my={3} alignItems="center" spacing={2}>
      <Info fontSize="large" color="info" />
      <Typography>Sorry, no media matched your criteria.</Typography>
    </Stack>

    <Typography>Search tips</Typography>
    <Divider />
    <List>
      <ListItem>
        The media must meet EVERY search criteria. (If more than one field is
        selected, the media must match each field exactly.)
      </ListItem>
      <ListItem>
        If you don't find any matches, choose fewer search criteria. If you find
        too many matches, choose more search criteria.
      </ListItem>
      <ListItem>
        When searching in the long description, title, or key words, type in
        only a word or partial phrase.
      </ListItem>
      <ListItem>
        Categories are linked to media type. When searching by category, only
        the corresponding categories will be displayed in the category drop
        down.
      </ListItem>
      <ListItem>
        If you can't find the desired category, select another media type.
      </ListItem>
      <ListItem>
        Performance numbers are tied to Documents. When searching on a
        performance number, make sure that Document is the media type selected.
      </ListItem>
    </List>
  </>
)
